import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import Header from '../../../common/header'
import Footer from '../../../common/footer'
import SvgIcon from '../../../common/svg-icon/svg-icon'
import { Button, Breadcrumb } from 'semantic-ui-react'
import './index.scss'

import Lithiumion from '../../../../assets/images/new-images/Lithiumion.png';
import Solar from '../../../../assets/images/new-images/Solar.png';
import OpticalFiber from '../../../../assets/images/new-images/OpticalFiber.png';
import GreenHydrogen from '../../../../assets/images/new-images/GreenHydrogen.png';
import CarbonFiber from '../../../../assets/images/new-images/CarbonFiber.png';
import UVECuring from '../../../../assets/images/new-images/UVECuring.jpg';
import Semiconductor from '../../../../assets/images/new-images/Semiconductor.jpg';
import AdditiveManufacturing from '../../../../assets/images/new-images/AdditiveManufacturing.jpg';

import { NewInviteUser } from '../../../common/newInviteUser';
import axios from 'axios';
import { BASE_URL } from '../../../../config/config';
import { replaceSpaceInName } from '../../../../common/helperMethods';

import CareesImg from '../../../../assets/images/new-images/careers.jpg';
import Rightsidebar from '../../../common/rightsidebar';
import IndustryValueChain from "../industry-valuechain/industry-valuechain";
import SEO from '../../../../components/seo/SEO';

const SolarVew = () => {
  const history = useHistory();
  const [CustomerSaysSlidesData, setCustomerSaysSlidesData] = useState([]);
  const [IndustriesData, setIndustriesData] = useState([]);
  const [solarData, setSolarData] = useState('');

  const [currentPpage, setCurrentPpage] = useState('Solar cells')
  const [default_industry, setdefault_industry] = useState('')
  const [default_industryID, setdefault_industryID] = useState('')

  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'ecosystem', content: 'Ecosystem', link: true, href: '/ecosystem' },
    { key: 'ecosystem', content: 'Solar', link: false },
  ]

  useEffect(() => {
    axios.get(`${BASE_URL}/api/v2/testimonials/list`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      setCustomerSaysSlidesData(data)

    }).finally(() => {
      //  setLoading(false)
    })

    axios.get(`${BASE_URL}/api/v2/industries/get`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      if (data.length > 0) {
        for (let index in data) {
          data[index]['image'] = '';

          if (data[index]['product']['id'] == "SkW9l-VnJRsG") {
            data[index]['image'] = OpticalFiber;
          }

          if (data[index]['product']['id'] == "HJpXxbE2yRjG") {
            data[index]['image'] = UVECuring;
          }

          if (data[index]['product']['id'] == "S1mF5ohWK") {
            data[index]['image'] = GreenHydrogen;
          }

          if (data[index]['product']['id'] == "HkqK_ZLfZvaDX") {
            data[index]['image'] = Semiconductor;
          }

          if (data[index]['product']['id'] == "S1aD-N21Ciz") {
            data[index]['image'] = CarbonFiber;
          }

          if (data[index]['product']['id'] == "rkxIVP6OrI") {
            data[index]['image'] = AdditiveManufacturing;
          }

          if (data[index]['product']['id'] == "ryh4YXLfWP6DX") {
            data[index]['image'] = Solar;
            console.log('data[index]  ', data[index]['id'])

            setSolarData(data[index])
          }

          if (data[index]['product']['id'] == "SyG_WFgFX") {
            data[index]['image'] = Lithiumion;
          }

        }
      }
      setIndustriesData(data)
      localStorage.setItem('industry_data', JSON.stringify(data));

      setTimeout(() => {

        setdefault_industry(solarData)
        if (solarData.product != undefined && solarData.product.id != undefined) {
          setdefault_industryID(solarData.product.id)
        }
      }, 1200);

    }).finally(() => {
      //  setLoading(false)
    })
  }, [])


  const gotoSolar = () => {
    if (solarData.name != undefined && solarData.id != undefined) {
      history.push(`/product/${replaceSpaceInName(solarData.name)}/${solarData.product.id}`);
    }
  }

  return (
    <>
      <SEO key="ecosystem-solar-seo"
        robots="index, follow"
        canonicalUrl="/ecosystem/solar"
        alternateLink="/ecosystem/solar"
        pageType={'ecosystem'}
        pageContent={{ pageName: 'Solar Module Value Chain: Technologies, Suppliers & Equipment', pageDescription: 'Explore solar module technologies, suppliers, and equipment across the complete value chain for efficient manufacturing.' }}

      />
      <Header />
      <div className='ecosystempage-view ecosystempage-inners'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>

        <section>
          <div className='mappes-container'>
            <div className='innerpages-wrapper-inner'>
              <div className='innerpages-left-section'>
                <div className='ecosysteminner-banner'>
                  <img className='banner-img' src={CareesImg} alt='' />
                  <div className='ecosysteminner-inner'>
                    <div className='upper-row'>
                      Navigate the Global Solar Technology Ecosystem
                    </div>
                    <p>
                      <b>
                        Polysilicon → Ingot → Wafer → Cell → Module → Power Generation
                      </b>
                      <br />
                      From metallurgical-grade silicon to power plant deployment, access the complete solar value chain — helping you discover technologies, companies, applications, and emerging opportunities across the ecosystem.
                    </p>
                    <div>
                      <Button onClick={() => gotoSolar()}>Explore Solar Cell Ecosystem </Button>
                    </div>
                  </div>
                </div>
                {solarData && <IndustryValueChain id={default_industryID} page={currentPpage} curentProd={solarData} />}
                <section className='mappessubcribe-section'>
                  <div className='mappessubcribe-card'>
                    <div className='mappessubcribe-row'>
                      <h2>Looking To Expand Your Market in <span>Solar Sector?</span></h2>
                      <NewInviteUser />
                    </div>
                  </div>
                </section>
              </div>

              {solarData.product != undefined && solarData.product.id != undefined && (
                <>
                  <Rightsidebar industry={solarData.product.id} show={'both'} />
                </>
              )}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default SolarVew